import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { OperatorInfo } from 'src/models/operator-info/OperatorInfo';

/**
 * # History
 *
 * History을 설명하세요.
 */
export const History = types
  .model('History')
  .props({
    historySid: types.number,
    historyDate: types.number,
    titleKo: types.maybeNull(types.string),
    titleEn: types.maybeNull(types.string),
    desc: types.maybeNull(types.string),
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
    regDt: types.optional(types.maybeNull(types.number), 0),
    updDt: types.optional(types.maybeNull(types.number), 0),
  })
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type THistory = Instance<typeof History>;
type THistorySnapshot = SnapshotOut<typeof History>;

export interface IHistory extends THistory {}
export type THistoryKeys = keyof THistorySnapshot & string;
export interface IHistorySnapshot extends THistorySnapshot {}
export const createHistory = () => types.optional(History, {} as THistory);
